import { Stack, Separator } from '@kiwicom/orbit-components';
import type { TranslationType } from '@kiwicom/account-consts';

import Text from './Text';

type Props = {
  readonly children: TranslationType;
  readonly spaceAfter?: 'normal' | 'large';
};

const SeparatorWithText = ({ children, spaceAfter = 'normal' }: Props): JSX.Element => {
  return (
    <Stack flex align="center" spaceAfter={spaceAfter} spacing="small">
      <Separator />
      <Text>{children}</Text>
      <Separator />
    </Stack>
  );
};

export default SeparatorWithText;
